import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, ConsultaReimpressaoFicState } from './types';

export const INITIAL_STATE: ConsultaReimpressaoFicState = {
	status: 0,
	numeroRg: '',
	data: {
		arquivoPdf: '',
		listErros: [],
	},
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultaReimpressaoFicState {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_REIMPRESSAO_FIC_REQUEST: {
				draft.numeroRg = action.payload.rg;
				break;
			}
			case Types.CONSULTA_REIMPRESSAO_FIC_SUCCESS: {
				draft.status = 200;
				draft.data.arquivoPdf = action.payload.pdfDataUrl;
				draft.data.listErros = action.payload.listErros;
				break;
			}
			case Types.CONSULTA_REIMPRESSAO_FIC_FAILURE: {
				draft.status = 400;
				draft.data = INITIAL_STATE.data;
				break;
			}
			case Types.CONSULTA_REIMPRESSAO_FIC_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.numeroRg = INITIAL_STATE.numeroRg;
				break;
			}

			default:
		}
		return draft;
	});
}
